import _ from 'lodash';
import { Checkbox, Tooltip } from 'antd';

import QueryDraggable from '../components/QueryDraggable';
import {
  checkNestedContainer,
  getContainerDisplayName,
  getPropertyData,
} from '../utils';
import RenderTitleQueryCondition from '../components/RenderRootTitle';

export const useRenderTree = () => {
  const mappingTreeTitle = ({
    draggingTaskId,
    queryConditionsId,
    queryConditions,
    propertiesList,
    PropertyAdvancedFilter = null,
    ...restProp
  }) => {
    const { handleConjunction, handleQueryCondition, viewMode } = restProp;
    let cloneQueryConditionData = _.cloneDeep(queryConditions);
    const rootKey = 'root';
    const keyList = [rootKey];

    const recursionRenderTreeProperty = ({
      dataConditions,
      parentValuePath,
    }) => {
      dataConditions?.forEach((conditionItem, index) => {
        const isParent = !!conditionItem?.children?.length;
        //* valuePath([]) is path of _.set, use for updating value, delete either as a key of tree item
        const valuePath = [...parentValuePath, index + ''];
        const key = valuePath.join('.');

        const property = getPropertyData({
          properties: propertiesList,
          fieldName: conditionItem?.fieldName,
        });

        property.children = conditionItem?.children ?? [];
        property.strictMode = conditionItem?.strictMode;
        property.id = conditionItem?.id;
        property.values = conditionItem?.values;
        property.valuePath = valuePath;
        property.value = conditionItem.value;
        property.otherValue = conditionItem.otherValue;
        property.isParent = isParent;
        property.operator = conditionItem.operator;
        property.acceptableValueTemp = conditionItem?.acceptableValueTemp;
        property.operation = conditionItem?.operation || 'AND';
        property.parentDisplayName = getContainerDisplayName(
          conditionItem,
          propertiesList
        );

        conditionItem['key'] = key;
        conditionItem['title'] = (
          <>
            {PropertyAdvancedFilter ? (
              <PropertyAdvancedFilter
                key={conditionItem?.id}
                property={property}
              />
            ) : (
              <QueryDraggable
                key={conditionItem?.id}
                index={index}
                draggableId={key}
                property={property}
                draggingTaskId={draggingTaskId}
                queryConditionsId={queryConditionsId}
                {...restProp}
              />
            )}
          </>
        );
        if (isParent) {
          recursionRenderTreeProperty({
            dataConditions: conditionItem?.children,
            parentValuePath: [...valuePath, 'children'],
          });
          keyList.push(key);
        }
      });
    }; //* end recursionRenderTreeProperty

    //* root fields
    cloneQueryConditionData['isParent'] = true;
    cloneQueryConditionData['key'] = rootKey;
    cloneQueryConditionData['title'] = (
      <>
        {PropertyAdvancedFilter ? (
          <PropertyAdvancedFilter
            key={cloneQueryConditionData?.rootKey}
            property={cloneQueryConditionData}
          />
        ) : (
          <div
            style={{
              display: 'flex',
              width: '100%',
            }}
          >
            <RenderTitleQueryCondition
              viewMode={viewMode}
              style={{
                marginTop: 8,
                with: '100%',
                flex: '1',
              }}
              isDragging={!!draggingTaskId}
              handleConjunction={handleConjunction}
              property={{
                valuePath: [],
                operation: cloneQueryConditionData?.operation,
              }}
            />
            <RenderStrictMode
              handleQueryCondition={handleQueryCondition}
              queryConditions={queryConditions}
            />
          </div>
        )}
      </>
    );

    recursionRenderTreeProperty({
      dataConditions: cloneQueryConditionData?.children,
      parentValuePath: ['children'],
    });

    cloneQueryConditionData['collapseKey'] = keyList;

    return cloneQueryConditionData;
  };

  return { mappingTreeTitle };
};

export const RenderStrictMode = ({ queryConditions, handleQueryCondition }) => {
  const isShowStrictMode = checkNestedContainer(queryConditions?.children);

  const onChange = (e) => {
    const value = e.target.checked;
    handleQueryCondition(queryConditions?.valuePath ?? [], value, 'strictMode');
  };

  return (
    <>
      {isShowStrictMode && (
        <Tooltip title='When the nested mode is enabled, only matching record data with the same parent entity will be considered.'>
          <Checkbox
            style={{ marginLeft: 'auto' }}
            onChange={(e) => onChange(e)}
            checked={queryConditions?.strictMode}
          >
            Nested Mode
          </Checkbox>
        </Tooltip>
      )}
    </>
  );
};
